var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub_title d_flex"},[_c('p',[_vm._v(_vm._s(_vm.textLeft))]),(_vm.showRight)?_c('a',{staticClass:"right",on:{"click":function($event){$event.preventDefault();return _vm.handleRight.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.textRight)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }